
export function customerService (data) {
    // 检测是否在微信小程序环境中
    const isWxMiniProgram = window.__wxjs_environment === 'miniprogram' || navigator.userAgent.indexOf('miniProgram') > -1;
    if (isWxMiniProgram) {
        if (window.wx && window.wx.miniProgram) {
          // 方式一：使用navigateTo强制触发通信
          const d = {
            corpId: data.corpId,
            url: data.url,
            id: data.id || 0,
            from: data.from || 0,
          }
          const p = Object.keys(d).reduce((p, k, i) => p + `${i ? '&' : '?'}${k}=${d[k]}`, '');
          const corpId = data.corpId;
          const serviceUrl = data.url;
          window.wx.miniProgram.navigateTo({
              url: `/pages/mine/kefu/kefu${p}`,
              success: function() {
                console.log('客服跳转指令已发送');
              },
              fail: function(err) {
                  console.error('跳转失败:', err);
                  // 如果失败，尝试postMessage作为备选
                  window.wx.miniProgram.postMessage({
                      data: {
                        type: 'contact_customer_service',
                        corpId: corpId,
                        url: serviceUrl
                      }
                  });
                  // 强制刷新页面以触发postMessage
                  setTimeout(() => {
                      window.location.reload();
                  }, 100);
              }
          });
      }
    } else {
      // 原有逻辑保持不变
      let u = navigator.userAgent
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
          if (window?.jxyy?.contactWxCustomerService) {
              window.jxyy.contactWxCustomerService(data.corpId, data.url)
          } else {
              window.location.href = data.url
          }
      } else if (isiOS) {
          if (window?.webkit?.messageHandlers?.contactWxCustomerService) {
            window.webkit.messageHandlers.contactWxCustomerService.postMessage("kf");
          } else {
            window.location.href = data.url
          }
      } else {
          window.location.href = data.url
      }
    }
}
